import { gql } from '@apollo/client';

import CLASSROOM_FRAGMENT from '../fragments/classroom';

const SEARCH_CLASSROOMS_QUERY = gql`
  query searchClassrooms(
    $searchText: String!
    $classroomIds: [Int!]
    $organizationIds: [Int!]
    $limit: Int
  ) {
    classrooms(
      where: {
        name_contains: $searchText
        archived: false
        OR: [{ id: $classroomIds }, { organizationId: $organizationIds }]
      }
      orderBy: { field: [NAME, ID], direction: [ASC, DESC] }
      paging: { limit: $limit }
    ) {
      ...BaseClassroom
    }
  }
  ${CLASSROOM_FRAGMENT}
`;

export default SEARCH_CLASSROOMS_QUERY;
